import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Header = ({ t, lang, setLang }) => (
  <motion.header
    initial={{ y: -80, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
    className="fixed top-0 left-0 right-0 z-50 glass"
    data-testid="site-header"
  >
    <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
      <Link
        to="/"
        data-testid="brand-logo-link"
        className="flex items-center gap-2 font-display font-bold tracking-tight text-base md:text-lg"
      >
        <img src="/logo.svg" alt="" className="w-7 h-7" />
        <span>
          Conjure<span className="text-magic">flow</span>
        </span>
      </Link>

      <nav className="flex items-center gap-6 md:gap-10">
        <Link
          to="/#giochi"
          data-testid="nav-games-link"
          className="hidden sm:block text-sm font-semibold text-white/70 hover:text-white transition-colors duration-300"
        >
          {t.nav.games}
        </Link>
        <Link
          to="/#manifesto"
          data-testid="nav-manifesto-link"
          className="hidden sm:block text-sm font-semibold text-white/70 hover:text-white transition-colors duration-300"
        >
          {t.nav.manifesto}
        </Link>
        <div
          className="flex items-center gap-1 text-xs font-bold tracking-widest border border-white/10 rounded-full px-1 py-1"
          data-testid="language-toggle"
        >
          {["it", "en"].map((l) => (
            <button
              key={l}
              data-testid={`lang-toggle-${l}`}
              onClick={() => setLang(l)}
              className={`px-3 py-1 rounded-full uppercase transition-colors duration-300 ${
                lang === l ? "bg-white/10 text-[#00F0FF]" : "text-white/40 hover:text-white/80"
              }`}
            >
              {l}
            </button>
          ))}
        </div>
      </nav>
    </div>
  </motion.header>
);

export default Header;
